{
  "info": "情報",
  "negative": "エラー",
  "notice": "警告",
  "positive": "成功"
}
